export enum UserRoles {
  GLOBAL_ADMIN = 'GLOBAL_ADMIN',
  TECHNICIAN = 'TECHNICIAN',
  TECHNICIAN_ADMIN = 'TECHNICIAN_ADMIN',
  SW_DEVELOPER = 'SW_DEVELOPER',
  SW_MANAGER = 'SW_MANAGER',
  PENDING_USER = 'PENDING_USER',
}
